import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { FilterBox, ExportToXLSBtn } from '../../../../ui'
import { ipFilterStyles } from './ip-filter.styles'
import { IP_FILTERS } from './ip-filter.constants'
import { IP_EXPORT_COLUMNS } from '../table/ip-table.constants'
import { ipExportDataPreparation } from '../../logics'
import { useIPCalls } from '../../hooks/ip-calls.hook'
import { useIPContext } from '../../contexts'
import feedback from '../../../../core/feedback'

import { setCombo } from '../../../combos/slices'
import { ipCatalogoService } from '../../services/ip-catalogo.service'

export const IPFilter = () => {
  const dispatch = useDispatch()
  const ipClasses = ipFilterStyles()
  const intl = useIntl()
  const { formatMessage } = intl
  const combos = useSelector((state) => state.combos)
  const { getIIPPCall } = useIPCalls()
  const { tableSelection, search } = useIPContext()

  useEffect(() => {
    ipCatalogoService.getProvincias().then((data) => {
      dispatch(setCombo({ comboId: 'ip_provincias', data }))
    })
    ipCatalogoService.getPlantillas().then((data) => {
      dispatch(setCombo({ comboId: 'ip_plantillas', data }))
    })
  }, [dispatch])

  const selectedProvincias = search?.id_provincia
  useEffect(() => {
    ipCatalogoService.getMunicipios({ id_provincia: selectedProvincias }).then((data) => {
      dispatch(setCombo({ comboId: 'ip_municipios', data }))
    })
  }, [selectedProvincias, dispatch])

  const filters = IP_FILTERS.map((item) => {
    const newItem = { ...item }
    if (newItem.comboId) {
      newItem.values = combos[newItem.comboId]?.data ?? combos[newItem.comboId]
    }
    return {
      ...newItem,
      label: formatMessage({
        id: 'pages.ip.filters.' + newItem.name + '.title',
      }),
    }
  })

  return (
    <FilterBox filters={filters} classes={ipClasses}>
      <ExportToXLSBtn
        exportSelectionEnabled={false}
        exportAllEnabled={true}
        selectedRows={tableSelection}
        columnsExport={IP_EXPORT_COLUMNS}
        getAllData={() => {
          return new Promise((resolve, reject) => {
            getIIPPCall({ params: { ...search, _num_x_pagina: 0 }, timeout: 0 })
              .then(({ data }) => {
                return resolve(ipExportDataPreparation({ data: data.registros, combos, intl }))
              })
              .catch((err) => {
                feedback('error', formatMessage({ id: 'global.errorDownload' }))
                return reject(err)
              })
          })
        }}
        titleRoot="ip_"
        headerNamespace="ipExport"
      />
    </FilterBox>
  )
}
